import { render, staticRenderFns } from "./FormSelectAuth.vue?vue&type=template&id=48d3dace&scoped=true"
import script from "./FormSelectAuth.vue?vue&type=script&lang=js"
export * from "./FormSelectAuth.vue?vue&type=script&lang=js"
import style0 from "./FormSelectAuth.vue?vue&type=style&index=0&id=48d3dace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d3dace",
  null
  
)

export default component.exports